export default {
  SET_NEWSLETTER_LOGS: function (state, payload) {
    state.newsletterLogs = payload;
  }
}
